import { formatCustomDate } from "helpers/dateTools";
import { convertToObjById } from "helpers/convertToObject";
import { convertToMapById } from "helpers/convertToMap";

export const CATALOGS_SET_WAREHOUSE_FILTERS = 'CATALOGS_SET_WAREHOUSE_FILTERS';
export const CATALOGS_REQUEST_WAREHOUSES_DATA = 'CATALOGS_REQUEST_WAREHOUSES_DATA';
export const CATALOGS_WAREHOUSE_SELECTED = 'CATALOGS_WAREHOUSE_SELECTED';
export const CATALOGS_GET_WAREHOUSES = 'CATALOGS_GET_WAREHOUSES';
export const CATALOGS_GET_LICENSE = 'CATALOGS_GET_LICENSE';
export const CATALOGS_CREATE_WAREHOUSE = 'CATALOGS_CREATE_WAREHOUSE';
export const CATALOGS_MOD_WAREHOUSE = 'CATALOGS_MOD_WAREHOUSE';
export const CATALOGS_DELETE_WAREHOUSE = 'CATALOGS_DELETE_WAREHOUSE';
export const CATALOGS_RESET_WAREHOUSE_SELECTED = 'CATALOGS_RESET_WAREHOUSE_SELECTED';
export const CATALOGS_ADD_WAREHOUSE_MODE = 'CATALOGS_ADD_WAREHOUSE_MODE';
export const CATALOGS_EDIT_WAREHOUSE_MODE = 'CATALOGS_EDIT_WAREHOUSE_MODE';
export const CATALOGS_CHECK_ADD_WAREHOUSE_MODE_PERMIT = "CATALOGS_CHECK_ADD_WAREHOUSE_MODE_PERMIT";
export const CATALOGS_DELETE_WAREHOUSE_MODE = "CATALOGS_DELETE_WAREHOUSE_MODE";

const initialState = {
  station: {},
  warehouses: {},
  warehousesArr: [],
  catalogWarehouseSelected: null,
  LicensesCRE: [],
  addWarehouse: true,
  addMode: false,
  deleteMode: false,
}

export const warehousesCatalogReducer = (state = initialState, action) => {

  switch (action.type) {
    case CATALOGS_SET_WAREHOUSE_FILTERS:
      return {
          ...state,
          [action.payload.key]: action.payload.data,
      };

    case CATALOGS_ADD_WAREHOUSE_MODE:
      return {
        ...state,
        addMode: true,
        deleteMode: false
      }

    case CATALOGS_EDIT_WAREHOUSE_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: false
      }

    case CATALOGS_DELETE_WAREHOUSE_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: true
      }
    
    case CATALOGS_CHECK_ADD_WAREHOUSE_MODE_PERMIT:
      return {
        ...state,
        addMovement: action.payload,
      }

    case CATALOGS_GET_WAREHOUSES:
      const filteredWarehouses = action.payload.filter(catalogTank => catalogTank?.number.length > 0).map(tank => {
        return {
          ...tank,
          expirationDate: formatCustomDate(tank.expirationDate, '-')
        }
      });
      const listTanks = convertToObjById(filteredWarehouses);
      return {
        ...state,
        warehouses: listTanks,
        warehousesArr: filteredWarehouses,
      }
    case CATALOGS_GET_LICENSE:
      const preparedLicenses = action.payload.map(license => {
        return {
          ...license,
          label: license.creLicense,
          value: license.creLicense
        }
      });
      return {
        ...state,
        LicensesCRE: preparedLicenses,
      }
    case CATALOGS_WAREHOUSE_SELECTED:
      return {
        ...state,
        catalogWarehouseSelected: action.payload && state.warehouses[action.payload]
      }
    case CATALOGS_RESET_WAREHOUSE_SELECTED:
      return {
        ...state,
        catalogWarehouseSelected: null
      }

    case CATALOGS_CREATE_WAREHOUSE:
      const addingWarehouse = [action.payload, ...state.warehousesArr]
      const newWarehouse = convertToObjById(addingWarehouse)
      return {
        ...state,
        warehouses: newWarehouse,
        warehousesArr: addingWarehouse,
      }

    case CATALOGS_MOD_WAREHOUSE:
      const editedWarehouses = {
        ...state.warehouses,
        [action.payload.id]: {
          ...state.warehouses[action.payload.id],
          ...action.payload
        },
      }
      return {
        ...state,
        warehouses: editedWarehouses,
        warehousesArr: convertToMapById(editedWarehouses),
      }

    case CATALOGS_DELETE_WAREHOUSE:
      const dataArray = state.warehousesArr.filter(catalogTank => catalogTank.id !== action.payload)
      return {
        ...state,
        warehouses: convertToObjById(dataArray),
        warehousesArr: dataArray,
      }

    default :
      return state
  }
}